import React, { Component } from 'react';

class TableHeader extends Component {
    render () {
        const columns = this.props.columns;
        return (
            columns.map((element, index) => 
                <li key={index} className="table-header">{element.title}</li>
            )
        );
    }
}

class Table extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const columns = this.props.columns;
        const groupProperty = this.props.groupProperty;
        const groupRendeder = this.props.groupRendeder;
        const showRowDetails = this.props.showRowDetails;
        const detailRenderer = this.props.detailRenderer;
        const addHeadersForNarrowScreen = this.props.addHeadersForNarrowScreen;

        const data = this.props.data;
        const preGridTemplateColumns = columns.map(col => {return (
                'minmax(' + (col.columnMinWidth ? col.columnMinWidth : 'auto') + ', ' + (col.columnMaxWidth ? col.columnMaxWidth : 'auto') + ')'
            )});
        const gridTemplateColumns = preGridTemplateColumns.join(' ');
        if (groupProperty) {
            const groups = (value, index, self) => {
                return self.indexOf(value) === index;
            }
            const distinctGroups = data.map(e => e[groupProperty]).filter(groups);
            return <div>
                {distinctGroups.map(group => {
                    let elements = data.filter(item => item[groupProperty] == group);
                    return (
                        <div>
                            <span className='chapter group'>{groupRendeder ? groupRendeder(group) : group}</span>
                            <ul className={this.props.className ? ("table " + this.props.className) : "table"}
                                style={{ "gridTemplateColumns": gridTemplateColumns }}>
                                <TableHeader columns={columns} />
                                {elements.map(element => {
                                    return (
                                        columns.map((col, index) => {
                                            if (col.render) {
                                                return (col.render(element[col.accesor], element, index, col))
                                            }
                                            else return (
                                                <li key={index} className={"table-content "}>
                                                    {this.props.addHeadersForNarrowScreen === true &&
                                                        <span className='table-mini-header'>
                                                            {col.title + ": "}
                                                        </span>
                                                    }
                                                    <span className={col.className}>{element[col.accesor]}</span>
                                                </li>
                                            )
                                        })
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </div>
        }
        else if (showRowDetails) {
            var headerClassName = ['table'];
            if (this.props.className) headerClassName.push(this.props.className);
            if (this.props.headerClassName) headerClassName.push(this.props.headerClassName);
            return (<div className='table'>
                <ul className={headerClassName.join(' ')}
                    style={{ "gridTemplateColumns": gridTemplateColumns }}>
                    <TableHeader columns={columns} />
                </ul>
                {data.map(element => {
                    var dataRow = columns.map((col, index) => {
                        if (col.render) {
                            return (col.render(element[col.accesor], element, index, col))
                        }
                        else return (
                            <li key={index} className={"table-content "}>
                                {addHeadersForNarrowScreen &&
                                    <span className='table-mini-header'>
                                        {col.title + ": "}
                                    </span>
                                }
                                <span className={col.className}>{element[col.accesor]}</span>
                            </li>
                        )
                    });

                    //var detailColumns = Object.keys(element[detailProperty][0]).map(p => { return { title: p, accesor: p }; });
                    //var detailTable = <Table data={element[detailProperty]} columns={detailColumns} />;

                    return <div className='table' style={{border: 'solid 1px'}}>
                        <ul className={this.props.className ? ("table " + this.props.className) : "table"}
                            style={{ "gridTemplateColumns": gridTemplateColumns }}>
                            {dataRow}
                        </ul>
                        <div>{detailRenderer(element)}</div>
                        {/*{element[detailProperty].map(item => {
                            //var detailColumns = Object.keys(item).map(p => { return { title: p, accesor: p }; });
                            //return <Table data={element[detailProperty]} columns={detailColumns} />

                            //return Object.keys(item).map(prop => <span>{item[prop]}</span>)
                            //})
                            //}</div>*/}
                    </div>
                })
                }
            </div>);
        }
        else {
            return (
                <ul className={this.props.className ? ("table " + this.props.className) : "table"}
                    style={{
                        "gridTemplateColumns": gridTemplateColumns }}>
                    <TableHeader columns={columns} />
                    {data.map(element => {
                        return (
                            columns.map((col, index) => {
                                if (col.render) {
                                    return (col.render(element[col.accesor], element, index, col))
                                }
                                else return (
                                    <li key={index} className={"table-content "}>
                                        {this.props.addHeadersForNarrowScreen === true &&
                                            <span className='table-mini-header'>
                                                {col.title + ": "}
                                            </span>
                                        }
                                        <span className={col.className}>{element[col.accesor]}</span>
                                    </li>
                                )
                            })
                        );
                    })}
                </ul>
            );
        }
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Table.jsx